import { connect } from 'react-redux';

import AutocompleteActions from 'reducers/autocomplete';

const mapStateToProps = ({ autocomplete, search: { searchParams }, location }) => ({
  searchSuggestions: autocomplete.searchSuggestions,
  isLoading: autocomplete.isLoading,
  location: searchParams.searchValues.location,
  currentLocation: location,
});

const mapDispatchToProps = {
  ...AutocompleteActions,
};

export default connect(mapStateToProps, mapDispatchToProps);
